import { createSlice } from '@reduxjs/toolkit';

export const logRocket = createSlice({
  name: 'LOGROCKET',
  initialState: {}, // this comes from preloadedState in the store

  reducers: {
    setLogRocketData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

const { actions, reducer } = logRocket;

export const { setLogRocketData } = actions;

export default reducer;
